import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CarrierDriverAddComponent } from './carrier-driver-add.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BusyModule } from 'app/busy/busy.module';
import { NgxIntlTelInputModule } from 'app/shared/projects/ngx-intl-tel-input/src/lib/ngx-intl-tel-input.module';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import { CarrierTypeModule } from 'app/shared/carrier-type/carrier-type.module';
import { NgxLoadingModule } from 'ngx-loading';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
  declarations: [
    CarrierDriverAddComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    NgbDatepickerModule,
    CarrierTypeModule,
    NgxLoadingModule.forRoot({}),
    PdfViewerModule,
  ],
  exports: [CarrierDriverAddComponent]
})
export class CarrierDriverAddModule { }
